import './MultipleChoiceQuestion.scss'
import Checkbox from './Checkbox'
import { useState } from 'react'

export default function CheckboxQuestion({ name, disabled, options, answer = {}, onChange: _onChange, className = '', notGraded }) {
  const [checked, setChecked] = useState(!!answer.valueInput)
  const onChange = (value) => {
    _onChange({ ...value, notGraded })
    setChecked((state) => !state)
  }

  return (
    <div className={`multiple-choice-question question ${className}`}>
      <div className='base'>
        <Checkbox
          disabled={disabled}
          label={name}
          onChange={() => {
            const value = !checked ? options.find(({ valueInput }) => valueInput === 'true') : { ...answer, value: null, valueInput: false }
            onChange(value)
          }}
          checked={checked}
        />
      </div>
      <div className={`expandable ${answer.allowcomment ? 'visible' : ''}`}>
        <textarea
          rows='3'
          placeholder='Type your reasoning here'
          onChange={({ target: { value: comment } }) => {
            if (answer.comment !== comment) onChange({ ...answer, comment })
          }}
          value={answer.comment || ''}
        />
      </div>
    </div>
  )
}
